'use strict';

import _ from 'lodash';

import './DateInput.less';

import React from 'react';
import PropTypes from 'prop-types';
import SelectInput from './SelectInput';
import DateInputLang from './DateInputLang';
import Verifier from 'ck-core/source/system/Verifier';
import Input from './Input.jsx';
import propIsVerifierInstance from 'ck-core/source/functions/propIsVerifierInstance';

const months = DateInputLang.MONTHS;

export default class DateInput extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			day: this.props.value ? this.props.value.getDate() : undefined,
			month: this.props.value ? months[this.props.value.getMonth()] : undefined,
			year: this.props.value ? this.props.value.getFullYear() : undefined
		};

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(key, value) {
		this.setState({
			[key]: value
		});
	}

	componentDidMount() {
		if (this.props.value) {
			this.validate(this.props.value);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (_.isEqual(prevState, this.state)) {
			return;
		}

		if (_.some(this.state, val => _.isNil(val))) {
			return;
		}

		const value = moment(
			`${this.state.year}-${this.state.month}-${this.state.day}`,
			'YYYY-MMMM-D'
		).toDate();

		if (prevProps.value && moment(prevProps.value).isSame(moment(value))) {
			return;
		}

		this.validate(value);

		this.props.onChange(value);
	}

	getSelectName(suffix) {
		return `${this.props.name}-${suffix}`;
	}

	async validate(value) {
		if (Verifier.isInstance(this.props.validate)) {
			try {
				await this.props.validate.verify(value, true);

				this.props.onValidate(true);
			} catch (err) {
				this.props.onValidate(false, err.message);
			}
		} else if (this.props.validate) {
			const result = await this.props.validate(value);

			this.props.onValidate(_.get(result, 'valid', true), _.get(result, 'error'));
		} else if (value) {
			this.props.onValidate(true);
		}
	}

	render() {
		let maxDays = 31;

		if (this.state.year && this.state.month) {
			maxDays = moment(`${this.state.year}-${this.state.month}`, 'YYYY-MMMM').daysInMonth();
		}
		let selectedYear = Number(this.state.year); // on rerender its being converted to string

		const firstDay =
			months[this.props.min.getMonth()] === this.state.month &&
			this.props.min.getFullYear() === selectedYear
				? this.props.min.getDate()
				: 1;
		const monthsRange =
			this.props.min.getFullYear() === selectedYear
				? months.slice(this.props.min.getMonth())
				: months;

		const days = _.range(firstDay, maxDays + 1);

		const toChoices = arr =>
			_.map(arr, val => ({
				key: '' + val,
				text: '' + val
			}));

		const years = _.range(this.props.min.getFullYear(), this.props.max.getFullYear()).reverse();
		return (
			<Input {...this.props} className="DateInput" virtualLabel={true}>
				<SelectInput
					name={this.getSelectName('day')}
					onChange={this.handleChange.bind(this, 'day')}
					value={this.state.day}
					choices={toChoices(days)}
					placeholder="Day"
				/>
				<SelectInput
					name={this.getSelectName('month')}
					onChange={this.handleChange.bind(this, 'month')}
					value={this.state.month}
					choices={toChoices(monthsRange)}
					placeholder="Month"
				/>
				<SelectInput
					name={this.getSelectName('year')}
					onChange={this.handleChange.bind(this, 'year')}
					value={this.state.year}
					choices={toChoices(years)}
					placeholder="Year"
				/>
			</Input>
		);
	}
}

DateInput.defaultProps = {
	min: new Date('1900-01-01'),
	max: new Date(),
	emptyValue: null
};

DateInput.propTypes = {
	min: PropTypes.instanceOf(Date),
	max: PropTypes.instanceOf(Date),
	value: PropTypes.instanceOf(Date),

	name: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	onValidate: PropTypes.func,
	validate: PropTypes.oneOfType([PropTypes.func, propIsVerifierInstance])
};
